import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// utils
// import localStorageAvailable from '../utils/localStorageAvailable';
//
import { defaultLang } from './config-lang';
//
import enLocales from './langs/en';
import frLocales from './langs/fr';
import deLocales from './langs/de';
import esLocales from './langs/es';
// import deLocales from './langs/fr';

// ----------------------------------------------------------------------

let lng = defaultLang.value;

// const storageAvailable = localStorageAvailable();

// if (storageAvailable) {
// lng = localStorage.getItem('i18nextLng') || defaultLang.value;
lng = defaultLang.value;
// }

i18n.use(initReactI18next).init({
  resources: {
    en: { translations: enLocales },
    fr: { translations: frLocales },
    // vn: { translations: vnLocales },
    // cn: { translations: cnLocales },
    // ar: { translations: arLocales },
    de: { translations: deLocales },
    es: { translations: esLocales },
  },
  lng,
  fallbackLng: defaultLang.value,
  debug: false,
  ns: ['translations'],
  defaultNS: 'translations',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
